import { Injectable, inject } from '@angular/core';
import { DateTimeHelper } from '../../calendar/util/date-time-helper';
import { TodoPlannerService } from './todo-planner.service';

@Injectable({
  providedIn: 'root',
})
export class TodoPlannerControlBarService {
  // DI
  private readonly todoPlannerService = inject(TodoPlannerService);

  public prev(): void {
    const todoPlannerModel = this.todoPlannerService.todoPlannerModel;
    const prevWeekStart = DateTimeHelper.subWeeks(todoPlannerModel.plannerStart, 1);

    todoPlannerModel.plannerStart = DateTimeHelper.startOfWeek(prevWeekStart, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });
    todoPlannerModel.plannerEnd = DateTimeHelper.endOfWeek(prevWeekStart, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });
    this.todoPlannerService.weekDays.set(
      DateTimeHelper.eachDayOfInterval(todoPlannerModel.plannerStart, todoPlannerModel.plannerEnd),
    );

    this.todoPlannerService.reloadTodoEntries$.next();
  }

  public today(): void {
    const today = new Date();
    const todoPlannerModel = this.todoPlannerService.todoPlannerModel;

    todoPlannerModel.plannerStart = DateTimeHelper.startOfWeek(today, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });
    todoPlannerModel.plannerEnd = DateTimeHelper.endOfWeek(today, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });
    this.todoPlannerService.weekDays.set(
      DateTimeHelper.eachDayOfInterval(todoPlannerModel.plannerStart, todoPlannerModel.plannerEnd),
    );

    this.todoPlannerService.reloadTodoEntries$.next();
  }

  public next(): void {
    const todoPlannerModel = this.todoPlannerService.todoPlannerModel;
    const nextWeekStart = DateTimeHelper.addWeeks(todoPlannerModel.plannerStart, 1);

    todoPlannerModel.plannerStart = DateTimeHelper.startOfWeek(nextWeekStart, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });
    todoPlannerModel.plannerEnd = DateTimeHelper.endOfWeek(nextWeekStart, {
      weekStartsOn: todoPlannerModel.weekStartsOn,
    });

    this.todoPlannerService.weekDays.set(
      DateTimeHelper.eachDayOfInterval(todoPlannerModel.plannerStart, todoPlannerModel.plannerEnd),
    );

    this.todoPlannerService.reloadTodoEntries$.next();
  }
}
